import * as Traveller from './components/Traveller.css';
export default {
    Traveller
};
